import { doc, setDoc } from 'firebase/firestore';
import { db } from '../../firebase/config';
import { getAdjustedExpirationDate } from './foodItemStorageRules';
import { getUserDatabase } from './getUserDatabase';

export async function moveFoodItemBetweenContainers(
  user,
  sourceContainerKey,
  destinationContainerKey,
  item
) {
  if (
    !user?.uid ||
    !sourceContainerKey ||
    !destinationContainerKey ||
    !item?.id ||
    sourceContainerKey === destinationContainerKey
  ) {
    return null;
  }

  const userDatabase = await getUserDatabase(user);
  const containers = userDatabase?.containers ?? {};
  const sourceItems = Array.isArray(containers[sourceContainerKey])
    ? containers[sourceContainerKey]
    : [];
  const destinationItems = Array.isArray(containers[destinationContainerKey])
    ? containers[destinationContainerKey]
    : [];

  const movedItem = sourceItems.find((existingItem) => existingItem.id === item.id) ?? {
    id: item.id,
    name: item.name,
    quantity: item.quantity,
    expirationDate: item.expirationDate,
  };
  const adjustedMovedItem = {
    ...movedItem,
    expirationDate: getAdjustedExpirationDate(
      sourceContainerKey,
      destinationContainerKey,
      movedItem.expirationDate
    ),
  };

  const nextDatabase = {
    ...userDatabase,
    containers: {
      ...containers,
      [sourceContainerKey]: sourceItems.filter((existingItem) => existingItem.id !== item.id),
      [destinationContainerKey]: [
        ...destinationItems.filter((existingItem) => existingItem.id !== item.id),
        adjustedMovedItem,
      ],
    },
  };

  await setDoc(doc(db, 'users', user.uid), nextDatabase, { merge: true });

  return {
    database: nextDatabase,
    movedItem: adjustedMovedItem,
  };
}
